import { landings } from "~/types/landings";
import {
  filterProps,
  filterPropsMark,
  filterPropsTop,
} from "~/utils/constants";
import { safeLocalStorage, safeSessionStorage } from "~/utils/safeStorage";

export function declOfNum(cnt, text_forms, addNum = true) {
  const n = Math.abs(cnt) % 100;
  const n1 = n % 10;
  if (n > 10 && n < 20) {
    return addNum ? `${cnt} ${text_forms[2]}` : text_forms[2];
  }
  if (n1 > 1 && n1 < 5) {
    return addNum ? `${cnt} ${text_forms[1]}` : text_forms[1];
  }
  if (n1 == 1) {
    return addNum ? `${cnt} ${text_forms[0]}` : text_forms[0];
  }
  return addNum ? `${cnt} ${text_forms[2]}` : text_forms[2];
}

export function daysTextForm(days) {
  if (days == 0) {
    return "сегодня";
  }
  if (days == 1) {
    return "завтра";
  }
  if (days == 2) {
    return "послезавтра";
  }
  if (days > 2) {
    return `через ${declOfNum(days, ["день", "дня", "дней"])}`;
  }
}

export function getMarkUrl(section, mark) {
  if (section.length > 0) section += "filter/";
  return `${section}marka-${mark}/`;
}

export function getModelUrl(section, mark, model) {
  if (section.length > 0) section += "filter/";
  return `${section + getMarkUrl("", mark)}model-${model}/`;
}

export function getTypeUrl(section, mark, model, type) {
  if (section.length > 0) section += "filter/";
  return `${section + getModelUrl("", mark, model)}kuzov-${type}/`;
}

export function getFilterUrl(
  sectionPageUrl,
  filter = {},
  newParam = {},
  pageNum = 1,
) {
  let filterUrl = {};
  if (newParam.marka) {
    if (filter.marka?.[0] === newParam.marka) {
      filterUrl = {};
    } else {
      filterUrl = {
        marka: newParam.marka,
      };
    }
  } else if (newParam.model) {
    if (filter.model?.[0] === newParam.model) {
      filterUrl = {
        marka: filter.marka,
      };
    } else {
      filterUrl = {
        marka: filter.marka,
        model: newParam.model,
      };
    }
  } else if (newParam.kuzov) {
    if (filter.kuzov?.[0] === newParam.kuzov) {
      filterUrl = {
        marka: filter.marka,
        model: filter.model,
      };
    } else {
      filterUrl = {
        marka: filter.marka,
        model: filter.model,
        kuzov: newParam.kuzov,
      };
    }
  } else if (newParam.complectacia) {
    filterUrl = JSON.parse(JSON.stringify(filter));
    if (filter.complectacia?.[0] === newParam.complectacia) {
      delete filterUrl.complectacia;
    } else {
      filterUrl.complectacia = [newParam.complectacia];
    }
  } else if (newParam.tip_kuzova) {
    filterUrl = JSON.parse(JSON.stringify(filter));
    if (filter.tip_kuzova?.[0] === newParam.tip_kuzova) {
      delete filterUrl.tip_kuzova;
    } else {
      filterUrl.tip_kuzova = [newParam.tip_kuzova];
    }
  } else if (Object.entries(newParam).length > 0) {
    const [key, value] = Object.entries(newParam)[0];
    filterUrl = JSON.parse(JSON.stringify(filter));
    if (filterUrl[key]) {
      if (filterUrl[key].includes(value)) {
        if (filterUrl[key].length === 1) {
          delete filterUrl[key];
        } else {
          filterUrl[key] = filterUrl[key].filter((val) => val !== value);
        }
      } else {
        filterUrl[key].push(value);
      }
    } else {
      filterUrl[key] = [value];
    }
  } else {
    filterUrl = JSON.parse(JSON.stringify(filter));
  }
  let filterUrlDecoded = "";
  [...filterPropsMark, ...filterPropsTop, ...filterProps].map((paramKey) => {
    let param = filterUrl[paramKey];
    if (!param) {
      return;
    }
    if (Array.isArray(param)) {
      if (param[0] === "to" || param[0] === "from") {
        param = param.join("-");
      } else {
        param = param.join("-or-");
      }
    }
    filterUrlDecoded += `/${paramKey}-${param}`;
  });
  // Сняли последнее значение — фильтра больше нет. Адрес «.../filter/» без
  // единого значения отвечает 404, поэтому возвращаемся к самому разделу
  if (!filterUrlDecoded) {
    return pageNum > 1 ? `${sectionPageUrl}?page=${pageNum}` : sectionPageUrl;
  }
  if (pageNum > 1) {
    return `${sectionPageUrl}filter${filterUrlDecoded}/?page=${pageNum}`;
  }
  return `${sectionPageUrl}filter${filterUrlDecoded}/`;
}

export function toQueryString(obj, urlEncode = false) {
  if (!obj) return null;
  const flattenObj = (x, path = []) => {
    const result = [];
    Object.keys(x).forEach((key) => {
      if (!Object.prototype.hasOwnProperty.call(x, key)) return;
      const newPath = path.slice();
      newPath.push(key);
      let vals = [];
      if (x[key] === null) {
        return;
      }
      if (typeof x[key] === "object") {
        vals = flattenObj(x[key], newPath);
      } else {
        vals.push({ path: newPath, val: x[key] });
      }
      vals.forEach((v) => {
        return result.push(v);
      });
    });
    return result;
  };
  let parts = flattenObj(obj);
  parts = parts.map((varInfo) => {
    if (varInfo.path.length === 1) {
      varInfo.path = varInfo.path[0]; // eslint-disable-line no-param-reassign
    } else {
      const first = varInfo.path[0];
      const rest = varInfo.path.slice(1);
      varInfo.path = `${first}[${rest.join("][")}]`; // eslint-disable-line no-param-reassign
    }
    return varInfo;
  });

  const queryString = parts
    .map((varInfo) => {
      return `${varInfo.path}=${varInfo.val}`;
    })
    .join("&");
  if (urlEncode) {
    return encodeURIComponent(queryString);
  }
  return queryString;
}

export function getEdostMinDays(edost) {
  let min = null;
  edost.map((item) => {
    const itemMin = parseInt(item.day.split("-")[0]);
    if (!min || itemMin < min) {
      min = itemMin;
    }
  });
  return min;
}

export function setCookie(name, value, days) {
  let expires = "";
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = `; expires=${date.toUTCString()}`;
  }
  document.cookie = `${name}=${value || ""}${expires};`;
}

const deselection = function (n, arr) {
  // eslint-disable-next-line no-return-assign
  return arr[
    ((n %= 100), n < 20 && n > 4)
      ? 2
      : [2, 0, 1, 1, 1, 2][((n %= 10), n < 5) ? n : 5]
  ];
};

export function days(days, w = "через") {
  if (days === -1) {
    return "Нет в наличии";
  }
  if (days === 0) {
    return "Сегодня";
  }
  if (days === 1) {
    return "Завтра";
  }
  if (days === 2) {
    return "Послезавтра";
  }
  if (days > 2) {
    return `${w} ${days} ${deselection(days, ["день", "дня", "дней"])}`;
  }
}

export function daysTk(days) {
  return `до ${days} ${deselection(days, ["дня", "дней", "дней"])}`;
}

export function getDateString(date) {
  const dat = new Date(date);
  return `${dat.getDay()}.${dat.getMonth()}.${dat.getFullYear()}`;
}

export function isServer() {
  return typeof window === "undefined";
}

export async function cacheFunctionData(
  cacheFunction,
  cacheName,
  reset = false,
  storageType = "session",
) {
  const storage =
    storageType === "session" ? safeSessionStorage : safeLocalStorage;

  let cacheData = {};
  if (!reset && cacheName) {
    cacheData = storage.getItem(cacheName);
    if (cacheData) {
      try {
        cacheData = JSON.parse(cacheData);
        return cacheData;
      } catch (error) {}
    }
  }
  const data = await cacheFunction();
  if (cacheName) {
    storage.setItem(cacheName, JSON.stringify(data));
  }
  return data;
}

export function setTextCity(host, domainData, text, cityName = "") {
  if (!text || typeof text !== "string") {
    return text;
  }
  // На главном домене (farkop.ru) город определяется выбором пользователя
  // (cityName), а не поддоменом. Если выбран конкретный город (не «Россия») —
  // подставляем его вместо данных домена.
  if (host === "farkop.ru" && cityName && cityName !== "Россия") {
    return text
      .replace(/#CITY#/g, `г. ${cityName}`)
      .replace(/#CITY_NAME#/g, `г. ${cityName}`)
      .replace(/ с установкой/g, "");
  }
  if (!domainData) {
    return text;
  }
  const subDomain = host.split(".")[0];
  if (subDomain === "msk") {
    return text.replace(/#CITY#/g, "Москве");
  }
  let textWithCity = text
    .replace(/#CITY#/g, domainData?.declension ?? "Санкт-Петербурге")
    .replace(/#CITY_NAME#/g, domainData?.declension ?? "Санкт-Петербурге");
  if (subDomain !== "msk" && subDomain !== "spb") {
    textWithCity = textWithCity.replace(/ с установкой/g, "");
  }
  return textWithCity;
}
export function checkIsBaltex(host = "") {
  return host.includes("baltex.ru");
}

export function checkIsLanding(host) {
  return landings.includes(host);
}

export function getCookieDomain() {
  let domain = window.location.host;
  if (domain.includes("localhost")) {
    return "localhost";
  }
  const domainArray = domain.split(".");
  if (domainArray.length > 2) {
    domain = `.${domainArray[1]}.${domainArray[2]}`;
  }
  return domain;
}

export function getProductPhotoById(photos) {
  return photos
    ? photos.map((pictureId) => {
        const path1 = pictureId.substr(0, 2);
        const path2 = pictureId.substr(2, 2);
        const path3 = pictureId.substr(4);
        return {
          thumb: `/images/${path1}/${path2}/${path3}/thumb.webp`,
          small: `/images/${path1}/${path2}/${path3}/small.webp`,
          full: `/images/${path1}/${path2}/${path3}/big.webp`,
        };
      })
    : [];
}

export function formatType(type) {
  if (type) {
    const year = new Date().getFullYear();
    // type = type.replace('(', '').replace(')', '').replace(' по наст.', `-${year}`).replace('- ', `-${year} `)
    type = type.replace(" по наст.", `-${year}`).replace("- ", `-${year} `);
    if (type[type.length - 1] === "-") {
      type += year;
    }
  }
  return type;
}

export function getType(name = "", code) {
  const nameParts = name?.split(" (");
  if (nameParts.length > 1) {
    return {
      gen: nameParts[0],
      name: formatType(nameParts[1].replace(")", "")),
      sort: +nameParts[1].substring(0, 4),
      code,
    };
  }
  return {
    gen: "",
    name: formatType(nameParts[0].replace("(", "").replace(")", "")),
    code,
  };
}

export function formatDate(input = "") {
  const months = [
    "января",
    "февраля",
    "марта",
    "апреля",
    "мая",
    "июня",
    "июля",
    "августа",
    "сентября",
    "октября",
    "ноября",
    "декабря",
  ];
  const [datePart] = input.split(" ");
  const [day, month] = datePart.split(".");
  return `${parseInt(day, 10)} ${months[parseInt(month, 10) - 1]}`;
}

export function getPictureById(pictureId, isBaltex = false) {
  if (!pictureId) {
    return null;
  }
  const path1 = pictureId.substr(0, 2);
  const path2 = pictureId.substr(2, 2);
  const path3 = pictureId.substr(4);
  return {
    thumb: `/images/${path1}/${path2}/${path3}/thumb.webp`,
    small: `/images/${path1}/${path2}/${path3}/small.webp`,
    full: isBaltex
      ? `/images/${path1}/${path2}/${path3}/scheme.webp`
      : `/images/${path1}/${path2}/${path3}/big.webp`,
  };
}

export function getPictureOrigById(
  pictureId,
  section = "images",
  format = "jpeg",
) {
  if (!pictureId) {
    return null;
  }
  const path1 = pictureId.substr(0, 2);
  const path2 = pictureId.substr(2, 2);
  const path3 = pictureId.substr(4);
  return `/images/${section}/${path1}/${path2}/${path3}/orig.${format}`;
}

export function getProductsPhotos(product, isBaltex = false) {
  return product.PHOTOS_NEW?.filter((item, index) => {
    if (isBaltex) {
      return product.PHOTO_DESCRIPTIONS?.[index] === "#схема#";
    }
    return true;
  }).map((pictureId) => {
    return getPictureById(pictureId, isBaltex);
  });
}

export function getFutureDate(days) {
  // Текущая дата
  const currentDate = new Date();

  // Добавляем количество дней
  currentDate.setDate(currentDate.getDate() + days);

  // Форматируем вывод: дата в формате "дд.мм" и день недели
  const formattedDate = currentDate.toLocaleDateString("ru-RU", {
    day: "2-digit",
    month: "2-digit",
  });
  const dayOfWeek = currentDate.toLocaleDateString("ru-RU", {
    weekday: "long",
  });

  // Возвращаем строку с датой и днем недели
  return `${formattedDate} (${dayOfWeek.charAt(0).toUpperCase() + dayOfWeek.slice(1)})`;
}

function isMostlyCyrillic(text) {
  const cyrillicCount = (text.match(/[а-яё]/gi) || []).length;
  const latinCount = (text.match(/[a-z]/gi) || []).length;
  return cyrillicCount > latinCount;
}

export function getWordLat(text) {
  const latinToCyrillicMap = {
    q: "й",
    w: "ц",
    e: "у",
    r: "к",
    t: "е",
    y: "н",
    u: "г",
    i: "ш",
    o: "щ",
    p: "з",
    "[": "х",
    "]": "ъ",
    a: "ф",
    s: "ы",
    d: "в",
    f: "а",
    g: "п",
    h: "р",
    j: "о",
    k: "л",
    l: "д",
    ";": "ж",
    "'": "э",
    z: "я",
    x: "ч",
    c: "с",
    v: "м",
    b: "и",
    n: "т",
    m: "ь",
    ",": "б",
    ".": "ю",
    "`": "ё",
  };

  const cyrillicToLatinMap = {};
  // eslint-disable-next-line guard-for-in,no-restricted-syntax
  for (const key in latinToCyrillicMap) {
    cyrillicToLatinMap[latinToCyrillicMap[key]] = key;
  }

  function latinToCyrillic(input) {
    return input
      .split("")
      .map((char) => latinToCyrillicMap[char.toLowerCase()] || char)
      .join("");
  }

  function cyrillicToLatin(input) {
    return input
      .split("")
      .map((char) => cyrillicToLatinMap[char.toLowerCase()] || char)
      .join("");
  }

  if (isMostlyCyrillic(text)) {
    return cyrillicToLatin(text);
  }
  return latinToCyrillic(text);
}

export function logTime(start, message = "", maxTime = 1) {
  const time = (Date.now() - start) / 1000;
  if (time > maxTime) {
    const dateTime = new Date().toLocaleString("ru-RU");
    // eslint-disable-next-line no-console
    console.log(`[${dateTime}] Time: ${time}s, ${message}`);
  }
}

export function logError(message, details) {
  const dateTime = new Date().toLocaleString("ru-RU");
  // eslint-disable-next-line no-console
  console.error(`[${dateTime}] ${message}`, details);
}

export function formatPrice(price = 0) {
  return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}

export function getWordSound(text) {
  const translitCyrToLatin = {
    а: "a",
    б: "b",
    в: "v",
    г: "g",
    д: "d",
    е: "e",
    ё: "yo",
    ж: "zh",
    з: "z",
    и: "i",
    й: "y",
    к: "c",
    л: "l",
    м: "m",
    н: "n",
    о: "o",
    п: "p",
    р: "r",
    с: "s",
    т: "t",
    у: "u",
    ф: "f",
    х: "x",
    ц: "c",
    ч: "ch",
    ш: "sh",
    щ: "shch",
    ъ: "",
    ы: "y",
    ь: "",
    э: "e",
    ю: "y",
    я: "ya",
  };

  const translitLatinToCyr = {
    a: "а",
    b: "б",
    v: "в",
    g: "г",
    d: "д",
    e: "е",
    yo: "ё",
    zh: "ж",
    z: "з",
    i: "и",
    y: "й",
    k: "к",
    l: "л",
    m: "м",
    n: "н",
    o: "о",
    p: "п",
    r: "р",
    s: "с",
    t: "т",
    u: "у",
    f: "ф",
    kh: "х",
    ts: "ц",
    ch: "ч",
    sh: "ш",
    shch: "щ",
    yu: "ю",
    ya: "я",
  };

  const isCyrillic = isMostlyCyrillic(text);

  if (isCyrillic) {
    return text
      .split("")
      .map((char) => {
        const lower = char.toLowerCase();
        return translitCyrToLatin[lower] !== undefined
          ? translitCyrToLatin[lower]
          : char;
      })
      .join("");
  }
  return text
    .split("")
    .map((char) => {
      const lower = char.toLowerCase();
      return translitLatinToCyr[lower] !== undefined
        ? translitLatinToCyr[lower]
        : char;
    })
    .join("");
}

export function isMoreThanOneYearAgo(timestamp = "") {
  if (!timestamp) {
    return false;
  }
  const [date] = timestamp.split(" ");
  const [day, month, year] = date.split(".").map(Number);
  const inputDate = new Date(year, month - 1, day);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const oneYearAgo = new Date(today);
  oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);
  return inputDate < oneYearAgo;
}

export function getCookie(name) {
  if (typeof document === "undefined") {
    return null;
  }
  const nameEQ = `${name}=`;
  const ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

export function getRoistatId() {
  if (typeof window !== "undefined" && window.roistat?.visit) {
    return window.roistat.visit;
  }
  return getCookie("roistat_visit") || undefined;
}

export function addRoistatIdToFormData(formData, fields) {
  const roistatId = getRoistatId();
  if (!roistatId || !fields) {
    return formData;
  }

  const updatedFormData = { ...formData };

  const fieldsList = Array.isArray(fields) ? fields : [];
  let roistatField;
  for (let i = 0; i < fieldsList.length; i++) {
    const field = fieldsList[i];
    if (
      field &&
      field.NAME &&
      typeof field.NAME === "string" &&
      field.NAME.toLowerCase().includes("roistat")
    ) {
      roistatField = field;
      break;
    }
  }

  if (roistatField && roistatField.CODE) {
    updatedFormData[roistatField.CODE] = roistatId;
  }

  return updatedFormData;
}

export function generateSiteMap(pages, host, isIndex = false) {
  let sitemap = "";
  if (isIndex) {
    sitemap +=
      '<?xml version="1.0" encoding="UTF-8"?><sitemapindex xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">';
  } else {
    sitemap +=
      '<?xml version="1.0" encoding="UTF-8"?><urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">';
  }
  const date = new Date();
  if (Array.isArray(pages)) {
    pages.map((page) => {
      // Настоящей даты нет — тег не выводим: пустой или выдуманный lastmod
      // обесценивает поле по всему файлу
      const lastmod = page.LASTMOD ? `<lastmod>${page.LASTMOD}</lastmod>` : "";
      if (isIndex) {
        sitemap += `<sitemap><loc>https://${host}${page.LOC}</loc>${lastmod}</sitemap>`;
      } else {
        sitemap += `<url><loc>https://${host}${page.LOC}</loc>${lastmod}</url>`;
      }
    });
  }
  if (isIndex) {
    sitemap += "</sitemapindex>";
  } else {
    sitemap += "</urlset>";
  }

  return sitemap;
}

// Экспортируем функции из roistatCheck
export { checkAndLogRoistatId, checkRoistatIdWithDelay } from "./roistatCheck";
export {
  isSearchRobot,
  isAggressiveBot,
  shouldSkipApiRequestForRobot,
} from "./botDetection";

export const applyText = (text, textBlocks) => {
  if (!text) {
    return "";
  }
  textBlocks.forEach((textBlock) => {
    text = text.replace(`#${textBlock.code}#`, textBlock.data.description);
  });
  return text;
};

export const applyTags = (text, tags) => {
  Object.keys(tags).forEach((key) => {
    if (!tags[key]) {
      return;
    }
    if (typeof tags[key] === "string") {
      // eslint-disable-next-line no-param-reassign
      text = text.replaceAll(`#${key}#`, tags[key]);
    } else if (Array.isArray(tags[key])) {
      tags[key].forEach((subValue) => {
        if (subValue?.VALUE) {
          // eslint-disable-next-line no-param-reassign
          text = text.replaceAll(`#${subValue.CODE}#`, subValue.VALUE);
        }
      });
    } else if (typeof tags[key] === "object") {
      if (tags[key].VALUE) {
        // eslint-disable-next-line no-param-reassign
        text = text.replaceAll(`#${key}#`, tags[key].VALUE);
      }
    }
  });
  return text.replaceAll("#CML2_ARTICLE#", tags.ARTICLE.VALUE);
};
